import React from 'react'

export default function CancelIconRed() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M5.9 15H10.1C13.6 15 15 13.6 15 10.1V5.9C15 2.4 13.6 1 10.1 1H5.9C2.4 1 1 2.4 1 5.9V10.1C1 13.6 2.4 15 5.9 15Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round"/>
        <path d="M5.90437 10.3667H9.34836C10.5384 10.3667 11.5044 9.40068 11.5044 8.21068C11.5044 7.02068 10.5384 6.05469 9.34836 6.05469H4.60938" stroke="#C73535" strokeWidth="1.5" stroke-miterlimit="10" strokeLinecap="round" stroke-linejoin="round"/>
        <path d="M5.599 7.14249L4.5 6.0365L5.599 4.9375" stroke="#C73535" strokeWidth="1.5" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
